const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export const uploadImage = async (file) => {
  // CRA inlines REACT_APP_* vars at build time. If a deploy build runs without
  // these set in the host's environment (Cloudflare Pages → Settings → Env
  // vars), they're literally `undefined` in the bundle and Cloudinary returns
  // a confusing "Upload preset not found". Fail loudly here instead.
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    console.error('[cloudinary] missing env vars at build time', {
      hasCloud: !!CLOUD_NAME,
      hasPreset: !!UPLOAD_PRESET,
    });
    throw new Error('Image upload is not configured for this build. Contact support.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: 'POST', body: formData }
  );

  // Surface Cloudinary's own error message — easier to debug than a generic toast.
  if (!res.ok) {
    let cloudinaryMessage;
    try {
      const err = await res.json();
      cloudinaryMessage = err?.error?.message;
    } catch { /* response wasn't JSON */ }
    throw new Error(cloudinaryMessage || `Image upload failed (${res.status})`);
  }

  const data = await res.json();
  return data.secure_url;
};
